import * as React from "react";
import { Icon } from "@chakra-ui/icon";
import { omit } from "@chakra-ui/utils";
/**
 * CheckboxIcon is used to visually indicate the checked or indeterminate
 * state of a checkbox.
 *
 * @todo allow users pass their own icon svgs
 */

export var CheckboxIcon = function CheckboxIcon(props) {
  var isIndeterminate = props.isIndeterminate;
  var iconProps = omit(props, ["isChecked", "isIndeterminate"]);
  return /*#__PURE__*/React.createElement(Icon, iconProps, isIndeterminate ? /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    height: "4",
    width: "20",
    x: "2",
    y: "10"
  }) : /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "9 21 1 13 4 10 9 15 21 3 24 6 9 21"
  }));
};